"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _ramda = require("ramda");

var _string_utility = require("../../../packages/common-utilities/src/string_utility.js");

var _string_utility2 = _interopRequireDefault(_string_utility);

var _reactDom = require("react-dom");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _sanitize_utility = require("../../../packages/common-utilities/src/sanitize_utility.js");

var _sanitize_utility2 = _interopRequireDefault(_sanitize_utility);

var _functional_utility = require("common-utilities/src/functional_utility");

var _reactIntl = require("react-intl");

var _accessibility_utility = require("../../../packages/common-utilities/src/accessibility_utility");

var _accessibility_utility2 = _interopRequireDefault(_accessibility_utility);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var mapIndexed = (0, _ramda.addIndex)(_ramda.map);

var FundAwards = function (_PureComponent) {
  _inherits(FundAwards, _PureComponent);

  function FundAwards(props) {
    _classCallCheck(this, FundAwards);

    var _this = _possibleConstructorReturn(this, (FundAwards.__proto__ || Object.getPrototypeOf(FundAwards)).call(this, props));

    _this.renderSingleAward = function (text, index) {
      var awardObjectWidth = _this.props.fundAwards.length > 1 ? 'width-percent-50' : 'width-percent-100';

      if (!(0, _functional_utility.isNilOrEmpty)(_this.props.visibleDataPoints) && (0, _ramda.includes)("SHOW_TW_FUND_AWARDS", _this.props.visibleDataPoints)) {
        if (_this.props.breakpoint >= 3) {
          awardObjectWidth = 'width-percent-' + parseInt(100 / Math.min(3, _this.props.fundAwards.length));
        }
      }

      var additionalStyling = "";
      var apacAwardMstarAlignment = (0, _ramda.includes)("AWARD_MORNINGSTAR_ALIGNMENT_APAC", _this.props.formattingRules || []);
      if (apacAwardMstarAlignment) {
        var maxColumns = _this.props.breakpoint > 3 ? 3 : 2;
        var columnWidth = Math.floor(100 / Math.min(maxColumns, _this.props.fundAwards.length));
        awardObjectWidth = 'width-percent-' + columnWidth;
        additionalStyling = " min-height-70";
      }

      return _react2.default.createElement(
        _react.Fragment,
        null,
        _react2.default.createElement(
          "div",
          { className: "flex-child " + awardObjectWidth + additionalStyling + " category " + (0, _functional_utility.ifMobileBreakpoint)(_this.props.breakpoint, "", "margin-bottom-20") + " float-left padding-right-20" },
          _react2.default.createElement("span", { key: index, "data-testid": "fund-award-text-" + index, id: "fund-award-text-" + index,
            dangerouslySetInnerHTML: { __html: _sanitize_utility2.default.runSanitizer(text) } }),
          _this.renderIcon("pdpSummaryAward_" + (index + 1))
        )
      );
    };

    _this.handleDisclosureIconClick = _this.handleDisclosureIconClick.bind(_this);
    return _this;
  }

  _createClass(FundAwards, [{
    key: "renderFundAwards",
    value: function renderFundAwards() {
      return mapIndexed(this.renderSingleAward, this.props.fundAwards);
    }
  }, {
    key: "renderIcons",
    value: function renderIcons() {
      var fundAwardObjects = document.querySelectorAll('div[data-testid^=fundAwardContainer]');

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = fundAwardObjects[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var fundAward = _step.value;

          var summaryAward = this.renderIcon("pdpSummaryAward_" + fundAward.getAttribute('idx'));
          _reactDom2.default.render(summaryAward, fundAward);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  }, {
    key: "renderIcon",
    value: function renderIcon(tooltipId) {
      var _this2 = this;

      if (!this.props.disclosure || (0, _ramda.isNil)(this.props.disclosure[tooltipId])) {
        return null;
      }

      return _react2.default.createElement(
        "span",
        { id: "disclosure-" + tooltipId, tabIndex: 0, className: "icon-info print-hide",
          role: "tooltip",
          onKeyDown: function onKeyDown(event) {
            return _accessibility_utility2.default.handleEnterClick(_this2, event, _this2.handleDisclosureIconClick.bind(_this2, event, tooltipId));
          },
          onClick: function onClick(event) {
            return _this2.handleDisclosureIconClick(event, tooltipId);
          }
        },
        " "
      );
    }
  }, {
    key: "handleDisclosureIconClick",
    value: function handleDisclosureIconClick(event, tooltipId) {
      var el = this.getIconEl(tooltipId);
      var elHeight = el.offsetHeight;
      var elWidth = el.parentNode.getBoundingClientRect().left;
      var elRect = el.getBoundingClientRect();
      var arrowHeight = 4;
      var docTop = document.documentElement && document.documentElement.scrollTop || document.body.scrollTop;

      var toolTipWidth = void 0,
          toolTipContentWidth = void 0,
          closeTipPosition = void 0,
          toolTipContentScroll = 'hidden';
      if (this.props.disclosure[tooltipId][0].length > 380) {
        if (this.props.breakpoint > 3) {
          elWidth -= 150;
          toolTipWidth = 570;
          toolTipContentWidth = 530;
          closeTipPosition = 530;
        } else {
          toolTipContentScroll = 'auto';
        }
      }
      var elOffset = {
        top: elRect.top + docTop + arrowHeight + elHeight,
        left: elWidth,
        arrowPosition: elRect.left - elWidth - 3,
        toolTipWidth: toolTipWidth,
        toolTipContentWidth: toolTipContentWidth,
        closeTipPosition: closeTipPosition,
        toolTipContentScroll: toolTipContentScroll
      };

      this.props.tooltip.openTooltip(elOffset, this.props.disclosure[tooltipId], null, true, event);
    }
  }, {
    key: "getIconEl",
    value: function getIconEl(tooltipId) {
      return document.getElementById("disclosure-" + tooltipId);
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          fundAwards = _props.fundAwards,
          childWidth = _props.childWidth,
          breakpoint = _props.breakpoint;

      if ((0, _ramda.length)(fundAwards) < 1) {
        return null;
      }

      var fundAwardParentWidth = (0, _ramda.length)(fundAwards) >= 2 ? childWidth * 2 * ((0, _ramda.length)(fundAwards) > 1 && (breakpoint === 3 || breakpoint === 1) ? 2 : 1) : childWidth;
      var apacAwardMstarAlignment = (0, _ramda.includes)("AWARD_MORNINGSTAR_ALIGNMENT_APAC", this.props.formattingRules || []);

      return _react2.default.createElement(
        "div",
        { className: "display-inline-block text-top width-percent-" + (apacAwardMstarAlignment ? '100' : fundAwardParentWidth),
          "data-testid": "fund-award",
          id: "fund-award" },
        _react2.default.createElement(
          "div",
          { className: "title font-regular tag margin-bottom-5" },
          _string_utility2.default.renderFormattedLabel("AWARDS", "pdp-fund-award")
        ),
        _react2.default.createElement(
          "div",
          { className: "flex-parent" },
          this.renderFundAwards()
        )
      );
    }
  }]);

  return FundAwards;
}(_react.PureComponent);

exports.default = (0, _reactIntl.injectIntl)(FundAwards, { withRef: true });